module.exports = __webpack_public_path__ + "html/press-swipable_a272feb90bfb37cd949ed398c72235a4.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/press-swipable.html
// module id = l0GU
// module chunks = 118